var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DES_EVO_TENANT_TOKEN, DES_EVO_USER_TOKEN, getConfig } from "@jti/fe-common";
import { getUser, sanitizeBaseUrl } from "../../utils";
import { Rest } from "../Rest";
export class MessagingApi extends Rest {
    constructor(baseUrl, tenantToken) {
        super(sanitizeBaseUrl(baseUrl));
        this.tenantToken = tenantToken;
        this.setCommonHeader(DES_EVO_TENANT_TOKEN, tenantToken);
    }
    static init() {
        if (!MessagingApi.instance) {
            const { EVO_DOMAIN, EVO_TENANT } = getConfig();
            MessagingApi.instance = new MessagingApi(EVO_DOMAIN, EVO_TENANT);
        }
        return MessagingApi.instance;
    }
    subscribeUser(_a) {
        return __awaiter(this, arguments, void 0, function* ({ token }) {
            const { ciam_token } = getUser();
            if (!ciam_token) {
                throw new Error("User is not logged in");
            }
            const { data, statusCode } = yield this.request("/api/messaging/push", {
                method: "POST",
                headers: {
                    [DES_EVO_USER_TOKEN]: ciam_token,
                },
                body: JSON.stringify({
                    firebase_token: token,
                }),
            });
            return { data, statusCode };
        });
    }
    unsubscribe(_a) {
        return __awaiter(this, arguments, void 0, function* ({ subscriptionId }) {
            const { ciam_token } = getUser();
            if (!ciam_token) {
                throw new Error("User is not logged in");
            }
            const { statusCode } = yield this.request(`/api/messaging/push/${subscriptionId}`, {
                method: "DELETE",
                headers: {
                    [DES_EVO_USER_TOKEN]: ciam_token,
                },
            });
            return { statusCode };
        });
    }
    unsubscribeFromEverything() {
        return __awaiter(this, void 0, void 0, function* () {
            const { ciam_token } = getUser();
            if (!ciam_token) {
                throw new Error("User is not logged in");
            }
            const { statusCode } = yield this.request("/api/messaging/push", {
                method: "DELETE",
                headers: {
                    [DES_EVO_USER_TOKEN]: ciam_token,
                },
            });
            return { statusCode };
        });
    }
}
//# sourceMappingURL=MessagingApi.js.map